import React, { memo } from 'react';
import { formatCodeName } from '../../common/utils';
import { NamedEntity } from '../../common/types';
import { FormSelectSelectionLabel } from '../../common/form/input/FormSelectSelectionLabel';
import { getCategoryLabel } from './utils';

export const DimensionClassifierValue = memo(
  ({
    classifier,
    category,
    allCategories,
    levelNumber,
  }: {
    classifier?: NamedEntity | null;
    category?: NamedEntity | null;
    allCategories?: boolean | null;
    levelNumber?: number | null;
  }) => {
    if (!classifier) {
      return null;
    }

    const classifierName = formatCodeName(classifier);
    const hasSupertitle = allCategories || levelNumber || category;

    return (
      <FormSelectSelectionLabel
        supertitle={hasSupertitle ? classifierName : undefined}
        ellipsis
      >
        {hasSupertitle
          ? getCategoryLabel(allCategories, levelNumber, category)
          : classifierName}
      </FormSelectSelectionLabel>
    );
  }
);
